import { TextInput, List, DatagridConfigurable } from 'react-admin';
import { columns } from './AppTrackerColumns';
import { genericCSVExporter } from '@/util/genericCSVExporter';
import {
  renderExportColumns,
  renderGridColumns,
  renderOmitList,
} from '@/components/ConfigurableColumns';
import { useMemo } from 'react';
import { DefaultPagination } from '@/components/DefaultPagination';
import { AppTrackerCommandPanel } from './AppTrackerCommandPanel';
import { createDateFilters } from '@/util/DateFilters';
import { ModernListActions } from '@/components/DefaultListActions';

export const listFilters = [
  <TextInput label="Id" key="id" source="_id" defaultValue="" />,
  <TextInput
    label="Event Name"
    key="eventName"
    source="eventName"
    defaultValue=""
  />,
  <TextInput
    label="User Id"
    key="userId"
    source="userId"
    defaultValue=""
  />,
  <TextInput
    label="Device Id"
    key="uniqueDeviceId"
    source="uniqueDeviceId"
    defaultValue=""
  />,
  ...createDateFilters('when'),
];

export const AppEventTrackerList = () => {
  const omitList = useMemo(() => renderOmitList(columns), []);

  const gridColumns = useMemo(() => renderGridColumns(columns), []);

  const sort = useMemo(
    () => ({ field: 'when', order: 'DESC' as const }),
    [],
  );

  return (
    <List
      resource="appTrackerEvents"
      perPage={25}
      filters={listFilters}
      actions={
        <ModernListActions
          collectionName="appTrackerEvents"
          exporter={documentsCsvExporter}
        />
      }
      sort={sort}
      queryOptions={{
        meta: {
          facet: false,
        },
      }}
      pagination={<DefaultPagination />}
    >
      <DatagridConfigurable
        bulkActionButtons={false}
        expand={AppTrackerCommandPanel}
        // expand={null}
        omit={omitList}
      >
        {gridColumns}
      </DatagridConfigurable>
    </List>
  );
};

const documentsCsvExporter = genericCSVExporter(
  'appTrackerEvents',
  renderExportColumns(columns),
);
